import Spacer from '@/common/components/spacer';
import BaseLoan from '@/icons/base-loan';
import Insurance from '@/icons/insurance';
import Maintenance from '@/icons/maintenance';
import { cn } from '@/shadcn-ui/utils';
import { Link } from 'react-router';

type OurSourcesIconVariant = 'BaseLoan' | 'Maintenance' | 'Insurance';

export interface OurSourcesSectionProps {
  title: string;
  text: string;
  link?: string;
  iconVariant: OurSourcesIconVariant;
}

export default function OurSourcesSection({
  title,
  text,
  link,
  iconVariant,
}: OurSourcesSectionProps) {
  const displaySalesPitchIcon = (variant: OurSourcesIconVariant) => {
    switch (variant) {
      case 'BaseLoan':
        return <BaseLoan />;
      case 'Maintenance':
        return <Maintenance />;
      case 'Insurance':
        return <Insurance />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-row items-start gap-2">
      <div className="flex shrink-0">{displaySalesPitchIcon(iconVariant)}</div>
      <div>
        <p className="body-strong">{title}</p>
        <Spacer variant="height8" />
        <p className="body inline">
          {text}
          {' ' /** Single space before 'View sources' text */}
        </p>
        {link ? (
          <Link
            to={link}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              'link-dashed-body',
              'hover:flexcar-neutral-10 decoration-solid hover:decoration-flexcar-neutral10 hover:decoration-solid focus:text-flexcar-neutral10'
            )}
          >
            View sources
          </Link>
        ) : null}
      </div>
    </div>
  );
}
